import { REAGION_SOATO } from '@/common/constants/regions';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  regionId?: string;
};

export const NavigateTitle: FC<Props> = ({ regionId }) => {
  const [areaName, setAreaName] = useState<string>('respublic');
  const { t } = useTranslation();
  const displayName = areaName ? t(areaName) : t('respublic');
  useEffect(() => {
    if (regionId) {
      setAreaName(
        String(REAGION_SOATO?.find((item) => item.id === regionId)?.name),
      );
    } else {
      setAreaName('respublic');
    }
  }, [regionId]);

  return (
    <div className="flex items-center gap-5">
      <p className="text-xl font-semibold">
        {displayName} {t('crop.monitoring')}
      </p>
    </div>
  );
};
